import { boxShadow, colors } from 'theme.constant';

//theme apply chung cho bộ filter
export const filterTheme = {
  overrides: {
    MuiOutlinedInput: {
      root: {
        '& .MuiInputBase-input': {
          borderColor: colors.primary[0],
          backgroundColor: colors.background[0]
        },
        boxShadow: boxShadow[0]
      }
    }
  }
};

//theme apply cho bộ button kèm background
// || hoặc tự viết comp button với background
export const ButtonWithBg = {
  overrides: {
    MuiButton: {
      root: {
        backgroundColor: colors.background[0],
        color: colors.primary[0],
        boxShadow: boxShadow[0]
      }
    }
  }
};
